/** Report (editor) vs Findings (sidebar) — used for mic toggle + R/F badge. */
export const MIC_TOGGLE_TARGET = {
  REPORT: "editor",
  FINDINGS: "sidebar",
};

/**
 * Badge + next mic start target.
 * Live session wins while recording; when idle, next start is always Findings
 * (dictation box) — not last editor focus.
 */
export function resolveMicToggleTarget({
  isEditorMicActive,
  isSidebarRecording,
}) {
  if (isEditorMicActive) return MIC_TOGGLE_TARGET.REPORT;
  if (isSidebarRecording) return MIC_TOGGLE_TARGET.FINDINGS;
  return MIC_TOGGLE_TARGET.FINDINGS;
}

export function getMicToggleLetter(target) {
  return target === MIC_TOGGLE_TARGET.REPORT ? "R" : "F";
}
